import { render, staticRenderFns } from "./DiscountPhoneChangeForm.vue?vue&type=template&id=0d12d606&"
import script from "./DiscountPhoneChangeForm.vue?vue&type=script&lang=js&"
export * from "./DiscountPhoneChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports